<template>
  <div class="c-pattern-filter">
    <label class="filter-name pl-2">{{ filter.name }}</label>
    <div class="filter-controls">
      <c-widget-input-switch
        label=""
        :ariaLabel="filter.name"
        :options="filterStatusOptions"
        :value="filter.status"
        @input="onChangeFilterStatus"
      />

      <v-button class="remove-filter p-2" variant="link" @click="$emit('removeFilter', filter.id)">
        <font-awesome-icon :icon="['fas', 'times-circle']" />
        <span class="sr-only">{{ $t('white-label.widgets.stockScreener.buttons.deleteFilter') }}</span>
      </v-button>
    </div>
  </div>
</template>

<script>
import CWidgetInputSwitch from '@custom/widgetContainer/CWidgetInputSwitch';

export default {
  name: 'c-pattern-filter',
  components: {
    CWidgetInputSwitch
  },
  props: {
    filter: {
      type: Object,
      required: true
    }
  },
  data() {
    return {};
  },
  computed: {
    filterStatusOptions() {
      return [
        {
          value: 'active',
          text: this.$t('white-label.widgets.stockScreener.labels.active')
        },
        {
          value: 'inactive',
          text: this.$t('white-label.widgets.stockScreener.labels.inactive')
        }
      ];
    }
  },
  methods: {
    onChangeFilterStatus(status) {
      this.$emit('updatePatternFilter', {
        id: this.filter.id,
        data: {
          status
        }
      });
    }
  }
};
</script>

<style lang="scss">
@import '~@/styles/components/custom/c-pattern-filter';
</style>
